import { render } from "./Why.vue?vue&type=template&id=3f46bb47&scoped=true"
import script from "./Why.vue?vue&type=script&lang=js"
export * from "./Why.vue?vue&type=script&lang=js"

import "./Why.vue?vue&type=style&index=0&id=3f46bb47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f46bb47"]])

export default __exports__